/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* global window */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { Col, Row } from 'reactstrap';
import { withTranslate } from 'react-redux-multilingual';
import { requestInsights } from 'Actions/NewsActions';
import Loader from 'components/Loader/Loader';
import Icon from 'components/Icon/Icon';
import './InsightItem.scss';
import accessTokenService from 'services/accessTokenService';

const InsightItem = props => {
	const {
		translate,
		newsId,
		heading,
		iconName
	} = props;
	const { format } = window || {};
	const [selectedDateIndex] = useState(0);
	const [fetchingNewsInsights, setFetchingNewsInsights] = useState(true);
	const [insightsData, setInsightsData] = useState([]);
	const selectedArticle = insightsData.length > 0 ? insightsData[selectedDateIndex] : {};
	const selectedArticleId = selectedArticle.articleId || '';
	const selectedArticleDate = selectedArticle.DocumentDate || '';
	const asOfDate = insightsData.length > 0 && insightsData[selectedDateIndex].DocumentDate;

	const { MD } = window;
	const { markitDigitalUrl } = MD || {};

	const dispatch = useDispatch();
	requestInsights(newsId);

	useEffect(() => {
		dispatch(requestInsights(newsId, response => {
			setInsightsData(get(response, 'data.items', []));
			setFetchingNewsInsights(false);
		}));
	}, [dispatch, newsId]);

	const pdfLink = useCallback(key => {
		return (
			<a
				key={key}
				href={`${markitDigitalUrl}/getpdf/${newsId}/${selectedArticleId}?token=${accessTokenService.retrieve()}&news=true`}
				target="_blank"
				rel="noopener noreferrer"
				className="pdf-link">
				<span aria-hidden>{translate('openPdf')}</span>
				<span className="sr-only">
					{translate('openPdfSr', { name: `${heading} ${format.monthDayShort(selectedArticleDate)}` })}
				</span>
				<Icon iconName="document" className="pdf-icon" style={{ width: 16, height: 16 }} />
			</a>
		);
	}, [format, heading, selectedArticleDate]);

	return (
		<>
			{fetchingNewsInsights ? <Loader /> : null}
			<Col className="insights-item">
				<Row noGutters className="link-row clearfix">
					<Col xs="auto" className="insight-icon-container">
						<Icon className="insight-icon" iconName={iconName} />
					</Col>
					<Col>
						<div className="insights-content">
							<p className="h5 heading">{heading}</p>
							<div className="as-of-date-footer">
								{`${translate('lastUpdated')}`}
								<br />
								{format.monthDayYear(asOfDate)}
							</div>
							{pdfLink(newsId)}
						</div>
					</Col>
				</Row>
			</Col>
		</>
	);
};

export default withTranslate(InsightItem);
